<template>

  <section class="hero" aria-labelledby="page-title">
    <div class="section__inner hero__inner">
      <h2 id="page-title">자격증</h2>
      <p></p>

    </div>
  </section>
  <!-- ✅ 교육 리스트 (표 형태) -->
  <section class="program-table" aria-label="교육 목록">
    <div class="program-table__inner">
      <h2 class="program-table__title">교육일정</h2>

      <!-- 헤더 -->
      <div class="program-table__head">
        <div class="th th--no">번호</div>
        <div class="th th--title">교육명</div>
        <div class="th th--period">교육일정</div>
        <div class="th th--deadline">접수마감일</div>
        <div class="th th--count">조회수</div>
        <div class="th th--status">접수상태</div>
      </div>

      <!-- 바디 -->
      <ul class="program-table__body">
        <li class="program-row" v-for="(vo, index) in eduList" :key="vo.eduId || index" @click="goToDetail(vo.eduId)">
          <div class="td td--no">{{ vo.no }}</div>
          <div class="td td--title">
            <div class="title__link ellipsis">
              {{ vo.title.length > 30 ? vo.title.slice(0, 30) + '…' : vo.title }}
            </div>
          </div>
          <div class="td td--period">{{ vo.eduStartAt?.slice(0, 10) }} ~ {{ vo.eduEndAt?.slice(0, 10) }}</div>
          <div class="td td--deadline">{{ vo.endAt }}</div>
          <div class="td td--count">{{ vo.viewCount }}</div>
          <div class="td td--status">
            <button class="status-badge is-open" v-if="vo.status == 'PUBLISHED'">접수중</button>
            <button v-else class="status-badge is-closed">접수 마감</button>
          </div>
        </li>
      </ul>
    </div>
  </section>


  <Pagination id="pagination" class="pagination" v-if="userJson.pagination" :gridInfo="userJson"
    @getGridData="getGridData" />


  <section class="search-section" aria-label="교육 검색">
    <div class="search-box">
      <!-- 커스텀 셀렉트: 라디오를 v-model로 묶어서 기존 searchCode 그대로 사용 -->
      <details class="select-custom" role="listbox" @toggle="selectOpen = $event.target.open">
        <summary aria-label="검색 구분 선택">
          <span class="selected-text" aria-live="polite"></span>
          <i class="fa-solid fa-caret-down" aria-hidden="true"></i>
        </summary>

        <div class="options" role="listbox">
          <input type="radio" name="searchScope" id="scope-all" value="all" v-model="searchCode" />
          <label role="option" :aria-selected="searchCode === 'all' ? 'true' : 'false'" data-label="전체" for="scope-all"
            @click="closeSelect">전체</label>

          <input type="radio" name="searchScope" id="scope-title" value="title" v-model="searchCode" />
          <label role="option" :aria-selected="searchCode === 'title' ? 'true' : 'false'" data-label="제목" for="scope-title"
            @click="closeSelect">제목</label>

          <!-- '제목 + 내용'은 기존 로직에서 all과 동일하게 처리 -->
          <input type="radio" name="searchScope" id="scope-title-content" value="all" v-model="searchCode" />
          <label role="option" :aria-selected="searchCode === 'all' ? 'true' : 'false'" data-label="제목 + 내용"
            for="scope-title-content" @click="closeSelect">제목 + 내용</label>
        </div>
      </details>

      <!-- 검색어 입력/버튼: 기존 로직 그대로 -->
      <input type="text" class="search-input" placeholder="검색어를 입력하세요." aria-label="검색어 입력" v-model.trim="searchText"
        @keyup.enter="handleSearch" />
      <button class="search-btn" @click="handleSearch">
        <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i> 검색
      </button>
    </div>
  </section>


</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useStore } from 'vuex';
import userJson from '@/models/gridInfo/user.json'
import Pagination from '@/components/common/grid/pagination.vue'


const store = useStore()
const router = useRouter()
const status = ref('all')

const searchText = ref('')
const searchCode = ref('all')
const selectOpen = ref(false)
const searchParam = computed(() => {
  return store.state.temp.searchParam
})


const pagingBean = computed(() => {
  return store.state.grid.pagination
})

const eduList = computed(() => store.state.grid.eduData)


const getGridData = async () => {
  const param = {
    pageNo: searchParam.value.pageNo,
    countPerRecord: searchParam.value.countPerRecord,
    search: searchText.value,
    typeCd: searchCode.value,
    status: 'PUBLISHED'
  }
  await store.dispatch('grid/eduList', param)
}

const handleSearch = async () => {
  await getGridData()
}

const closeSelect = (e) => {
  const root = e?.target?.closest('details')
  if (root) root.open = false
}


onMounted(async () => {
  await getGridData()
})

const goToDetail = (code) => {
  router.push({
    name: 'trainingdetail',
    query: {
      eduId: code //
    }
  })
}

onUnmounted(() => {
  store.commit('temp/clearSearchParam')
  // 페이지 닫힐 때 해당 리스너 삭제

}) 
</script>

<style scoped>
.hero {
  background:
    linear-gradient(rgba(13, 6, 20, .65), rgba(13, 6, 20, .65)),
    url('/src/assets/certificationMain.jpeg') center 70% / 65% no-repeat;
  color: #fff;
}

.hero__inner {
  padding: 130px 16px;
  text-align: center;
}

.hero h2 {
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 40px;
  text-align: center;
  letter-spacing: -1px;
  line-height: 1.3;
}

.hero p {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin-top: 12px;
  letter-spacing: -0.3px;
  line-height: 1.6;
}

/* 컨테이너 */
.program-table {
  padding: 30px 0 60px;
  /* border-top: 1px solid #e5e7eb; */
}

.program-table__inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 12px;
}

.program-table__title {
  font-size: 1.625rem;
  font-weight: 700;
  color: #001b3b;
  font-family: 'Noto Sans KR', sans-serif;
  margin: 30px 0;
}

/* 그리드 헤더 */
.program-table__head {
  display: grid;
  grid-template-columns: 60px 1fr 250px 150px 120px 140px;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border: 1px solid #e5e5e5;
  border-bottom: 0;
  background: #ffffff;
  font-weight: 700;
  color: #0f172a;
  text-align: center;
}

.th {
  font-size: 15px;
}

/* 바디 */
.program-table__body {
  border: 1px solid #e5e5e5;
  border-top: 0;
  background: #fff;
}

.program-row {
  display: grid;
  grid-template-columns: 60px 1fr 250px 150px 120px 140px;
  gap: 12px;
  align-items: center;
  padding: 16px;
  border-top: 1px solid #f1f5f9;
  text-align: center;
  cursor: pointer;
}

.program-row:first-child {
  border-top: 0;
}

.program-row:hover {
  background: #fafafa;
}

/* 셀 */
.td {
  font-size: 15px;
  color: #111827;
}

.td--no {
  color: #374151;
}

.td--title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.title__link {
  text-decoration: none;
  color: #0f172a;
}

.title__link:hover {
  text-decoration: underline;
}

.title__icon {
  font-size: 14px;
  color: #9ca3af;
}

/* 긴 제목 말줄임 */
.ellipsis {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 상태 뱃지 */
.status-badge {
  min-width: 120px;
  height: 40px;
  padding: 0 14px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 14px;
  border: 0;
}

.status-badge.is-open {
  background: #2152ff;
  /* 파랑 */
  color: #fff;
}

.status-badge.is-closed {
  background: #ebeef2;
  /* 연회색 */
  color: #9aa3ad;
}

/* 검색 영역 레이아웃 */
.search-section {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px 0 80px;
}

.search-box {
  display: grid;
  grid-template-columns: 160px 1fr auto;
  gap: 10px;
  max-width: 620px;
  width: 100%;
}

/* 레이아웃은 grid */
.search-section .search-box {
  display: grid;
  grid-template-columns: 200px 1fr auto;
  gap: 10px;
  align-items: center;
}

/* 타이틀 규격 (필요 시 섹션 제목에 적용) */
.search-section .title {
  font-size: 1.625rem;
  font-weight: 700;
}

/* 설명글(p) 규격 */
.search-section p {
  font-size: 0.95rem;
}

/* 반응형 */
@media (max-width: 600px) {
  .search-section .search-box {
    grid-template-columns: 1fr;
  }
}

/* ============ 커스텀 셀렉트 ============ */
.select-custom {
  /* 기본값(라디오 선택에 따라 바뀜) */
  --selected: "전체";
  position: relative;
  width: 100%;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 0.95rem;
}

/* 요약(닫힘 상태 보이는 칸) */
.select-custom>summary {
  list-style: none;
  /* 기본 삼각형 제거 */
  display: flex;
  justify-content: space-between;
  /* 텍스트/아이콘 좌우 중앙정렬 */
  align-items: center;
  /* 수직 중앙정렬 */
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  user-select: none;
  outline: none;
}

/* 포커스/호버 */
.select-custom>summary:focus-visible,
.select-custom>summary:hover {
  border-color: #1d2088;
}

/* 열렸을 때 아래 상자와 시각적으로 이어지도록 하단 둥근 모서리 제거 */
.select-custom[open]>summary {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* ▼ 아이콘 */
.select-custom>summary .fa-caret-down {
  font-size: 0.9rem;
  color: #555;
}

/* 선택된 텍스트: CSS 변수로 반영 */
.select-custom .selected-text::after {
  content: var(--selected);
  display: inline-block;
  line-height: 1.4;
}

/* 옵션 상자 */
.select-custom .options {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(100% - 1px);
  /* 테두리 겹치게 해서 '아래 라인 끊김' 방지 */
  border: 1px solid #ccc;
  border-top: none;
  /* summary 테두리와 이어지게 */
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #fff;
  box-shadow: 0 6px 14px rgba(0, 0, 0, .08);
  z-index: 30;
}

/* 네이티브 input 숨기기 */
.select-custom .options input[type="radio"] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* 옵션 라벨 스타일 */
.select-custom .options label {
  display: block;
  padding: 10px 12px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.95rem;
}

/* 호버/포커스 */
.select-custom .options label:hover,
.select-custom .options label:focus {
  background: #f3f4f6;
}

/* 접근성: 현재 선택 항목 강조(라디오 checked 근처 라벨에 스타일) */
.select-custom:has(#scope-all:checked) label[for="scope-all"],
.select-custom:has(#scope-title:checked) label[for="scope-title"],
.select-custom:has(#scope-title-content:checked) label[for="scope-title-content"] {
  background: #eef2ff;
  color: #1d2088;
  font-weight: 700;
}

/* ✅ 선택값을 summary에 반영 (JS 없이) */
.select-custom:has(#scope-all:checked) {
  --selected: "전체";
}

.select-custom:has(#scope-title:checked) {
  --selected: "제목";
}

.select-custom:has(#scope-title-content:checked) {
  --selected: "제목 + 내용";
}

/* ============ 검색 인풋 + 버튼 ============ */
.search-input {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 0.95rem;
  padding: 10px 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.2s ease;
}

.search-input:focus {
  border-color: #1d2088;
}

.search-btn {
  background-color: #1d2088;
  color: #fff;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.25s ease;
}

.search-btn:hover {
  background-color: #141664;
}

/* 반응형(선택) */
@media (max-width: 600px) {
  .search-box {
    grid-template-columns: 1fr;
  }
}
</style>